import { MimeModel } from '@jupyterlab/rendermime';
import { Sanitizer } from '@jupyterlab/apputils';
import { standardRendererFactories } from '@jupyterlab/rendermime';
export class MimeRenderer {
    rank;
    mimetypes;
    render(mimeType, data, metadata) {
        return new HTMLElement();
    }
    ;
}
export class JupyterMimeRenderer extends MimeRenderer {
    constructor(factory) {
        super();
        this._factory = factory;
        this.rank = factory.defaultRank;
        this.mimetypes = [...factory.mimeTypes];
    }
    render(mimeType, data, metadata) {
        const renderer = this._factory.createRenderer({
            mimeType,
            resolver: null,
            sanitizer: new Sanitizer(),
            linkHandler: null,
            latexTypesetter: null,
            markdownParser: null,
            translator: null,
        });
        const model = new MimeModel({
            trusted: true,
            data: { [mimeType]: data },
            metadata: metadata,
        });
        renderer.renderModel(model);
        return renderer.node;
    }
    _factory;
}
export class BeakerRenderer {
    constructor(options) {
        this._renderers = {};
        for (const factory of standardRendererFactories) {
            const renderer = new JupyterMimeRenderer(factory);
            this.addRenderer(renderer);
        }
        for (const renderer of options?.renderers) {
            this.addRenderer(renderer);
        }
    }
    addRenderer(renderer) {
        for (const mimetype of renderer.mimetypes) {
            if (!Object.keys(this._renderers).includes(mimetype)) {
                this._renderers[mimetype] = renderer;
            }
            else {
                const prev_renderer = this._renderers[mimetype];
                if (renderer.rank <= prev_renderer.rank) {
                    this._renderers[mimetype] = renderer;
                }
            }
        }
    }
    get rankedMimetypes() {
        const mimetypes = Object.keys(this._renderers);
        mimetypes.sort((a, b) => this._renderers[a].rank - this._renderers[b].rank);
        return mimetypes;
    }
    render(mimeType, data, metadata) {
        const renderer = this._renderers[mimeType];
        if (renderer) {
            return renderer.render(mimeType, data, metadata);
        }
    }
    renderMimeBundle(bundle, metadata) {
        const result = {};
        for (const mimeType in bundle) {
            result[mimeType] = this.render(mimeType, bundle[mimeType], metadata);
        }
        return result;
    }
    rankedMimetypesInBundle(bundle) {
        const result = this.rankedMimetypes.filter((mime) => bundle && Object.keys(bundle).includes(mime));
        return result;
    }
    _renderers;
}
